import { DateTime } from "luxon";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../utils/dates/dates.constants";
import type { ColumnDefinitionProps } from "./columns.types";

interface GetDateColumnProps<
  T extends MRT_RowData
> extends ColumnDefinitionProps<T> {
  renderUndefinedAs?: React.ReactNode;
  dateDisplayFormat?: string;
}

function getDateColumn<T extends MRT_RowData>({
  key,
  options,
  renderUndefinedAs = "",
  dateDisplayFormat = DATE_DISPLAY_FORMAT
}: GetDateColumnProps<T>): MRT_ColumnDef<T> {
  return {
    id: key,
    header: "Datum",
    accessorFn: (row) =>
      row?.[key]
        ? backendDateOrDateTimeToLuxonDateTime(row?.[key]).toJSDate()
        : undefined,
    sortingFn: "datetime",
    filterVariant: "date",
    Cell: ({ cell }) => {
      const date = cell.getValue<Date>();
      if (!date) {
        return renderUndefinedAs;
      }
      return DateTime.fromJSDate(date).toFormat(dateDisplayFormat);
    },
    ...options
  };
}

export { getDateColumn };
